import React from 'react'
import PropTypes from 'prop-types'

const FormIMGS = ({ handleSubmit }) => {
    return (
        <>
            <form onSubmit={handleSubmit}>
            
                <div className="form-floating mb-3">
                    <input type="text" name="IMGinput" id="floatingInput" className="form-control" placeholder="..." />
                    <label htmlFor="floatingInput">Search your favorite topic:</label>
                </div>
                <div className="form-floating mb-3">
                    <input type="number" name="numIMG" id="numIMG" className="form-control" placeholder="..." />
                    <label htmlFor="numIMG">Select the N° of images you want:</label>
                </div>

                <button type="submit" className="btn btn-outline-dark d-flex m-auto w-50 mb-3 btnsearch"><span className="ms-auto">Search!</span> <i className="bi bi-search ms-auto"></i></button>

        
        </form>   
        </>
    )
}

FormIMGS.propTypes = {
    handleSubmit: PropTypes.func,
}

export default FormIMGS
